import { useAuth } from "context/AuthContext";
import Egypt from "../Egypt";
import AnnualPerformanceChart from "../AnnualPerformanceChart";
import { useLanguage } from "context/LanguageContext";
import { roundNumber } from "../../utils/roundNumber";
import CustomCircularProgressBar from "../customCharts/customCircularProgressBar";

const DashboardMiddleColumn = ({
    wisdomData, selectedOrg, selectedCenter, selectedMonthIdx,
    arrangedOrg, arrangedOrgIdx, handleSelectOrganization,
    setSelectedOrg, setSelectedOrgId, setArrangedOrgIdx,
    filteredSubjects, selectedSubject, setSelectedSubject,
    filteredStages, setSelectedStage, selectedStage,
    filteredSpecializations, selectedSpecialization, setSelectedSpecialization,
    fromDate, setFromDate, toDate, setToDate,
    loading, mapIds
}) => {
    // Custom Tools
    const { userInfo } = useAuth();
    const { language } = useLanguage(false);

    const changeOrg = (status) => {
        if (status && (arrangedOrgIdx + 1) !== arrangedOrg.length) {
            setArrangedOrgIdx(prev => prev + 1);
            setSelectedOrg(arrangedOrg[arrangedOrgIdx + 1]);
            setSelectedOrgId(arrangedOrg[arrangedOrgIdx + 1].id);
        } else if (!status && (arrangedOrgIdx) !== 0) {
            setArrangedOrgIdx(prev => prev - 1);
            setSelectedOrg(arrangedOrg[arrangedOrgIdx - 1])
            setSelectedOrgId(arrangedOrg[arrangedOrgIdx - 1].id);
        } else if (status && (arrangedOrgIdx + 1) === arrangedOrg.length) {
            setArrangedOrgIdx(0);
            setSelectedOrg(arrangedOrg[0])
            setSelectedOrgId(arrangedOrg[0].id);
        } else if (!status && (arrangedOrgIdx) === 0) {
            setArrangedOrgIdx(arrangedOrg.length - 1);
            setSelectedOrg(arrangedOrg[arrangedOrg.length - 1]);
            setSelectedOrgId(arrangedOrg[arrangedOrg.length - 1].id);
        }
    }

    return (
        <div className="w-full md:w-[45%] md:h-full rounded-xl py-2" style={{
            background: "#2d3347",
            minHeight: 260,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
        }}>
            {/* Title */}
            <div className="xl:text-2xl md:text-base text-sm font-bold text-amber-400">المؤشرات الاجمالية للمشروع</div>
            {/* Map */}
            <div className="relative w-full max-w-full flex justify-center items-center" style={{
                height: 400,
                maxHeight: 400,
                minWidth: 260,
                minHeight: 260,
                margin: '0 auto',
            }}>
                <div className="md:w-[50%] w-[90%] md:h-full h-[90%]">
                    <Egypt
                        width="100%"
                        height="100%"
                        ids={mapIds}
                        markerSrc={require("../../assets/marker.png")}
                        markerSize={80}
                        showLabels
                        handleSelectOrganization={handleSelectOrganization}
                    />
                </div>
                {/* Selected center evaluation circle with arrow and info box */}
                {selectedCenter && (
                    <>
                        {/* Evaluation circle as circular progress bar */}
                        <div className="flex flex-col justify-center items-center"
                            style={{
                                position: 'absolute',
                                right: `-15px`,
                                top: `25px`,
                                zIndex: 15,
                            }}>
                            <div
                                style={{
                                    width: 100,
                                    height: 100,
                                    borderRadius: '50%',
                                    zIndex: 15,
                                    background: 'none',
                                    boxShadow: '0 0 15px #0af8',
                                }}>
                                <CustomCircularProgressBar value={roundNumber(arrangedOrg[arrangedOrgIdx]?.months[selectedMonthIdx]?.performance || 0) || 0} size={100} />
                            </div>
                            <h1 className="w-[60%] text-xl text-center">الكفاءة و الفاعلية العامة</h1>
                        </div>
                        {/* Info box */}
                        {selectedOrg?.id !== "All" && <div style={{
                            position: 'absolute',
                            left: `25px`,
                            bottom: `40px`,
                            background: '#c3c8d6',
                            color: '#222',
                            padding: '10px 15px',
                            borderRadius: 16,
                            fontSize: 12,
                            width: 125,
                            maxWidth: 160,
                            boxShadow: '0 4px 16px #0004',
                            zIndex: 16,
                        }}>
                            <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{selectedOrg?.id === "All" ? language ? selectedOrg?.en_name : selectedOrg?.ar_name : selectedOrg?.name}</div>
                            <div style={{ fontSize: 9, marginBottom: 2 }}>{selectedCenter.address || 'No address'}</div>
                            {selectedCenter.location && (
                                <a
                                    href={`https://www.google.com/maps?q=${selectedCenter.location}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        fontSize: 9,
                                        color: '#1a237e',
                                        textDecoration: 'none',
                                        display: 'block',
                                        marginBottom: 2
                                    }}
                                >
                                    📍 فتح في جوجل ماب
                                </a>
                            )}
                            <div style={{ fontSize: 8, color: '#006400' }}>
                                تاريخ بدء المشروع: {selectedCenter.startDate || 'غير محدد'}
                            </div>
                        </div>}
                    </>
                )}
            </div>
            {/* Organization navigation */}
            <div className="w-full flex justify-between items-center px-2"
                style={{
                    marginTop: 18,
                    gap: 18,
                }}>
                {(userInfo?.user_role === "Operations Excellence Lead" || userInfo?.user_role === "Super Admin" || userInfo?.user_role === "Wisdom Observer") && <button
                    onClick={() => changeOrg(false)}
                    style={{
                        background: '#181f2e',
                        color: '#0af',
                        border: 'none',
                        borderRadius: '50%',
                        width: 36,
                        height: 36,
                        fontSize: 22,
                        fontWeight: 900,
                        cursor: 'pointer',
                        boxShadow: '0 2px 8px #0006',
                        transition: 'background 0.2s',
                    }}
                    title="المركز السابق"
                >
                    &#8592;
                </button>}
                <span className={`${selectedOrg?.id === "All" ? "font-bold text-2xl" : "text-md"}`} style={{ color: selectedOrg?.id === "All" ? "#fbbf24" : '#fff', fontWeight: 700, minWidth: 80, textAlign: 'center', letterSpacing: 1 }}>
                    {selectedOrg?.id === "All" ? selectedOrg?.ar_name || '' : selectedOrg?.name || ''}
                </span>
                {(userInfo?.user_role === "Operations Excellence Lead" || userInfo?.user_role === "Super Admin" || userInfo?.user_role === "Wisdom Observer") && <button
                    onClick={() => changeOrg(true)}
                    style={{
                        background: '#181f2e',
                        color: '#0af',
                        border: 'none',
                        borderRadius: '50%',
                        width: 36,
                        height: 36,
                        fontSize: 22,
                        fontWeight: 900,
                        cursor: 'pointer',
                        boxShadow: '0 2px 8px #0006',
                        transition: 'background 0.2s',
                    }}
                    title="المركز التالي"
                >
                    &#8594;
                </button>}
            </div>
            {/* Monthly Chart */}
            <AnnualPerformanceChart
                data={selectedOrg ? selectedOrg.months : wisdomData?.total?.months}
                title={`تحليل معدل تغيير الاداء ${selectedOrg?.id === "All" ? "للمشروع" : selectedOrg?.name}`}
                loading={loading}
                height={"md:h-[40%] h-[250px] w-full"}
                containerStyle={{ background: "", boxShadow: 'none' }}
            />
            {/* filters */}
            <div className="w-full flex items-center gap-4 px-4 mt-4" dir="rtl">
                <select className="w-[20%] h-8 flex items-center gap-2 px-3 py-1 m-0 rounded-full bg-white text-black text-xs font-semibold cursor-pointer" value={selectedSpecialization} onChange={(e) => setSelectedSpecialization(e.target.value)}>
                    <option value="" disabled>اختيار تخصص الطلاب</option>
                    <option value="All">الكل</option>
                    {filteredSpecializations.map(specialization =>
                        <option value={specialization.id}>{specialization.name}</option>
                    )}
                </select>
                <select className="w-[20%] h-8 flex items-center gap-2 px-3 py-1 m-0 rounded-full bg-white text-black text-xs font-semibold cursor-pointer" value={selectedStage}
                    onChange={(e) => setSelectedStage(e.target.value)}>
                    <option value="" disabled>اختيار المرحلة التعليمية</option>
                    <option value="All">الكل</option>
                    {filteredStages.map(stage =>
                        <option value={stage.id}>{stage.name}</option>
                    )}
                </select>
                <select className="w-[20%] h-8 flex items-center gap-2 px-3 py-1 m-0 rounded-full bg-white text-black text-xs font-semibold cursor-pointer" value={selectedSubject} onChange={(e) => setSelectedSubject(e.target.value)}>
                    <option value="" disabled>اختيار المادة</option>
                    <option value="All">الكل</option>
                    {filteredSubjects.map(subject =>
                        <option value={subject.id}>{subject.name}</option>
                    )}
                </select>
                <label className="w-[20%] h-8 flex items-center gap-2 px-3 py-1 m-0 rounded-full bg-white text-black text-sm font-semibold cursor-pointer">
                    من:
                    <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        className=" w-full min-w-0 max-w-full bg-transparent outline-none text-sm cursor-pointer overflow-hidden "
                    />
                </label>
                <label className="w-[20%] h-8 flex items-center gap-2 px-3 py-1 m-0 rounded-full bg-white text-black text-sm font-semibold cursor-pointer">
                    إلى:
                    <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        className=" w-full min-w-0 max-w-full bg-transparent outline-none text-sm cursor-pointer overflow-hidden "
                    />
                </label>
            </div>
        </div>
    )
};

export default DashboardMiddleColumn;